export default {
  bannerEventsData: {
    es: [{
      name: 'medium',
      imageBanner: '',
      imageDesktopXL: '/assets/images/events/banner-events-desktop-xl.svg',
      imageDesktop: '/assets/images/events/banner-events-desktop.svg',
      imageTablet: '/assets/images/events/banner-events-mobile.svg',
      imageMobile: '/assets/images/events/banner-events-mobile.svg',
      text1: '',
      text2: 'Disfrutamos compartiendo',
      text3: 'en nuestros eventos',
      buttonText: '',
      buttonLink: '',
      buttonTarget: '',
    }],

    en: [],
  },
};
